import { BillDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/finance/v1/bill_events_pb';
import { BillStatus } from '@rematter/frontend-lib-api-client/grpc/finance/v1/domain_pb';
import { BadgeField, Col, FieldDisplay, ThemeColor } from '@rematter/ui-web';

import { billStatusLabels, billTypeLabels } from '../enumLabels';

import { useTranslations } from '@/finance/i18n/useTranslations';

const getStatusColor = (status: BillStatus): ThemeColor => {
  switch (status) {
    case BillStatus.PENDING:
      return 'warning';
    case BillStatus.PAID:
      return 'success';
    case BillStatus.VOIDED:
      return 'failure';
    default:
      return 'neutral';
  }
};

type BillDeletedDetailProps = {
  event: BillDeletedEvent;
};

export const BillDeletedDetail = ({ event }: BillDeletedDetailProps) => {
  const t = useTranslations();
  const bill = event.bill;

  if (!bill) {
    return (
      <Col className="@BillDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>{t.logs.noDataAvailable}</span>
      </Col>
    );
  }

  const formatAmount = () => {
    if (!bill.amount) return 'N/A';
    const value = Number(bill.amount.amount) / 100;
    return `${bill.amount.currency} ${value.toFixed(2)}`;
  };

  return (
    <Col className="@BillDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          {t.logs.deletedBill}
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <FieldDisplay label="Document Number" value={bill.documentNumber} />
          <BadgeField
            label="Status"
            value={billStatusLabels[bill.status]}
            color={getStatusColor(bill.status)}
          />
          <FieldDisplay label="Type" value={billTypeLabels[bill.type]} />
          <FieldDisplay label="Amount" value={formatAmount()} />
          <FieldDisplay label="Facility ID" value={bill.facilityId?.value} />
          <FieldDisplay label="Account ID" value={bill.accountId?.value} />
        </div>
      </Col>
    </Col>
  );
};
